export default __webpack_public_path__ + "static/crew-622c41bab0cce25034f6646c087857c3.svg";